<template>
	<StepTemplate
		title="Your Charter Quotes"
		:restricted-height="true"
		:isLoading="isLoading"
		:nextNavigation="{ disabled: isNextDisabled }"
		v-on="$listeners"
		@prev="onPrev"
		@next="onNext"
	>
		<transition name="fade">

			<!-- Aircraft options were found -->
			<div v-if="hasOptions">
				<p class="type--serif">{{ optionsText }}</p>
				<div class="helicopter-cards">
					<FlytAircraftCard
						v-for="(option, index) in options"
						:key="index"
						:aircraft="option"
						:swiperIndex="index"
						:class="{'is-selected' : option.cheapestCraft.id === selectedID}"
						@selected="selectHelicopterByID"
					/>
				</div>
				<p class="type--s">All prices are estimates. Please check final prices and terms and conditions.</p>
			</div>

			<!-- Aircraft options weren't found -->
			<AircraftNotFound v-if="noAircraftFound"/>
		</transition>

		<template #footer>
			<button
				class="button is-primary is-wide type--serif type--m"
				:disabled="isNextDisabled"
				@click="onSubmit"
			>Next</button>
		</template>
	</StepTemplate>
</template>

<script>
import StepTemplate from "./StepTemplate"
import FlytAircraftCard from "@/components/booking/form/steps/aircraft/AircraftCard"
import AircraftNotFound from "@/components/booking/form/steps/AircraftNotFound"
import { mapGetters, mapActions, mapMutations } from "vuex"

export default {
	name: "OperatorsStep",

	components: { StepTemplate, FlytAircraftCard, AircraftNotFound },

	computed: {
		...mapGetters("bookingForm", ["loadingStep"]),
		...mapGetters("summary", {
			summaryStatus: "status",
			hasSummary: "hasSummary"
		}),
		...mapGetters("operators", [
			"options",
			"selectedID"
		]),

		/**
		 * Check whether step is loading
		 */
		isLoading() {
			return this.loadingStep === 2
		},

		/**
		 * Check whether loading has finished and no options found
		 */
		noAircraftFound() {
			return !this.isLoading && this.options.length === 0
		},

		/**
		 * Check whether loading has finished and options returned
		 */
		hasOptions() {
			return !this.isLoading && this.options.length > 0
		},

		/**
		 * Intro text above aircraft options
		 */
		optionsText() {
			return this.options.length > 1
				? `Choose from the following ${this.options.length} options:`
				: `One option available:`
		},

		/**
		 * Check whether an aircraft has been selected
		 */
		isNextDisabled() {
			return this.selectedID === null
		}
	},

	methods: {
		...mapMutations("bookingForm", ["setStepLoading"]),
		...mapActions("operators", [
			"addHelicopterToBooking",
			"clearState"
		]),
		...mapActions("summary", ["fetchSummary"]),

		/**
		 * Handle helicopter selection on click
		 */
		selectHelicopterByID(clickedID) {
			if (this.selectedID === clickedID)
				return

			this.addHelicopterToBooking(clickedID)
		},

		onPrev() {
			this.clearState()
			this.$emit('prev')
		},

		onNext() {
			this,this.submitStep()
		},

		onSubmit() {
			this.submitStep()
			this.$emit("next")
		},

		submitStep() {
			if (this.hasSummary)
				return

			this.setStepLoading(3)
			this.fetchSummary()
		},
	},
}
</script>

<style lang="scss" scoped>
.helicopter-cards {
	margin: 0 -1rem 1.5rem;
}
</style>
